'use strict';

var AR = require('component/core/core.js');

module.exports = function () {
	return [{
		id: 'Gallen',
		coords: [9.377, 47.424],
		name: AR.locale({
			ru: 'Галлен',
			en: 'Gallen'
		}),
		text: '',
		features: ['filter1', 'filter2']
	}, {
		id: 'Cyprus',
		name: AR.locale({
			ru: 'Кипр',
			en: 'Cyprus'
		}),
		text: '',
		features: ['filter2']
	}, {
		id: 'Moscow',
		coords: [37.617, 55.756],
		name: AR.locale({
			ru: 'Москва',
			en: 'Moscow'
		}),
		text: '',
		type: ['filter3']
	}];
};


/*****************
 ** WEBPACK FOOTER
 ** ./~/callback-loader/callback-loader.js!./frontend/components/map/data.js
 ** module id = 35
 ** module chunks = 0
 **/